// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import './hooks'; // This must be imported before any component
import '@babel/polyfill';
import VueLazyload from 'vue-lazyload';
import VueMoment from 'vue-moment';
import iframeResizerContent from 'iframe-resizer/js/iframeResizer.contentWindow.min';
import 'promise-polyfill/src/polyfill';

import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.prototype.$eventBus = new Vue();

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
});

Vue.use(iframeResizerContent);

Vue.use(VueMoment);

/* eslint-disable no-new */
new Vue({
  el: '#bookingApp',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/apps/booking/main.js